<div class="product-type-description-container mat-typography mat-body mat-app-background">

  @if (isAuthoring || productTab === productGroups.MEDICARE_ADVANTAGE) {
    <div>
      @if (isAuthoring) {
        <p>
          Medicare Advantage Banner Below
        </p>
      }
      <slot name="medicare_advantage_banner"></slot>
    </div>
  }

  @if (isAuthoring || productTab === productGroups.MEDICARE_SUPPLEMENT) {
    <div>
      @if (isAuthoring) {
        <p>
          Medicare Supplement Banner Below
        </p>
      }
      <slot name="medicare_supplement_banner"></slot>
    </div>
  }

  @if (isAuthoring || productTab === productGroups.MEDIGAP) {
    <div>
      @if (isAuthoring) {
        <p>
          Medigap Banner Below
        </p>
      }
      <slot name="medigap_logo_banner"></slot>
    </div>
  }

  @if (isAuthoring || productTab === productGroups.PRESCRIPTION_DRUG_PLAN) {
    <div>
      @if (isAuthoring) {
        <p>
          PDP Banner Below
        </p>
      }
      <slot name="prescription_drug_plan_banner"></slot>
    </div>
  }

  @if (isAuthoring || productTab === productGroups.WHOLE_HEALTH_BALANCE) {
    <div>
      @if (isAuthoring) {
        <p>
          Whole Health Balance Banner Below
        </p>
      }
      <slot name="whole_health_balance_banner"></slot>
    </div>
  }
</div>